import React, { useState, useRef, useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/authenticationActions';
import { QrCodeIcon } from '@heroicons/react/20/solid';
import { ClipboardIcon, KeyIcon } from '@heroicons/react/24/outline';
import { CodeInput, getSegmentCssWidth } from 'rci';

const MFASetup = ({
    mfa,
    initiateMFA,
    verifyMFA,
    logout,
    profileLoaded,
    companyRequired,
}) => {

    const inputRef = useRef(null);

    const [showQR, setShowQR] = useState(true);

    const width = getSegmentCssWidth('10px');

    useEffect(() => {
        if (profileLoaded) initiateMFA();
    }, [profileLoaded]);

    if(mfa?.success) return null;

    return (
        <>
            <div className="mx-8 my-8">
                {companyRequired ?
                    <h4 className="mb-4 font-bold" style={{ marginBottom: 20, textAlign: "center" }}>Your organisation requires you to set up MFA to access Buddy</h4>
                    : null
                }
                {(mfa?.setup.qrImg &&
                    <>
                        <ol style={{ listStyle: "auto" }} className="mb-4">
                            <li>Download and open an authenticator app on your phone</li>
                            <li>Scan the Buddy QR Code on the app</li>
                        </ol>
                        {showQR ?
                            <img src={mfa?.setup.qrImg} alt="QR Code" className="mb-4" style={{ display: "block", marginLeft: "auto", marginRight: "auto", height: 150, width: 150, maxHeight: 150, maxWidth: 150 }} />
                            :
                            <div>
                                <input className="inline-block w-full mb-4" disabled value={mfa?.setup.secret} />
                                <div
                                    className="bg-gray-200 hover:bg-gray-300 font-bold py-2 px-4 rounded text-gray-500 w-24 h-11 mb-4 mx-auto"
                                    onClick={() => navigator.clipboard.writeText(mfa?.setup.secret)}
                                    style={{ marginLeft: 5, cursor: "pointer" }}
                                >
                                    <ClipboardIcon style={{ height: "1.5em", float: "left" }} />
                                    <div style={{ float: "left" }}>Copy</div>
                                </div>
                            </div>
                        }
                        <div
                            className="bg-gray-200 hover:bg-gray-300 font-bold py-2 px-4 rounded text-gray-500 w-48 h-11 mx-auto"
                            onClick={() => setShowQR(!showQR)}
                            style={{ marginLeft: 5, marginBottom: 20, cursor: "pointer" }}
                        >
                            {showQR ? <KeyIcon style={{ height: "1.5em", float: "left" }} /> : <QrCodeIcon style={{ height: "1.5em", float: "left" }} />}
                            <div style={{ float: "left", paddingLeft: 10 }}>{showQR ? "Show Setup Key" : "Show QR Code"}</div>
                        </div>
                        <div className="clearfix" />
                        <p className="mb-4 text-center">Once you've added the Multi-Factor Authentication (MFA) on your phone, insert the 6-digit key below.</p>
                        {/* Source from https://codesandbox.io/s/rci-codeinput-812up?file=/src/Example.tsx */}
                        <CodeInput
                            id="mfa-setup-key"
                            inputRef={inputRef}
                            length={6}
                            spellCheck={false}
                            inputMode='numeric'
                            pattern='[0-9]*'
                            style={{ height: 40, marginBottom: 10 }}
                            inputClassName="mfa-input"
                            className="mfa-div"
                            inputStyle={{ height: 40 }}
                            autoComplete='off'
                            onChange={({ currentTarget: input }) => {
                                // only accept numbers
                                input.value = input.value.replace(/\D+/g, '');

                                if (input.value.length === 6) verifyMFA(input.value);
                            }}
                            renderSegment={({ state, index }) => (
                                <div
                                    key={index}
                                    className='segment'
                                    data-state={state}
                                    style={{ width, flex: "none", height: '100%', border: "2px solid rgb(209, 213, 219)", borderRadius: "0.375rem" }}
                                    children={<div />}
                                />
                            )}
                        />
                        {companyRequired ?
                            <div className="font-s13 text-right push-5-t text-orange-600">
                                <a onClick={() => logout()} style={{ cursor: "pointer" }}>Nope, take me back</a>
                            </div>
                            : null
                        }
                    </>
                ) || (
                        "Loading..."
                    )
                }
            </div>
        </>
    );
}

const mapStateToProps = (state) => {

    return {
        mfa: state.my.mfa,
        profileLoaded: !!state?.my?.profile?.email,
    }
}

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch(ACTIONS.logout()),
    initiateMFA: () => dispatch(ACTIONS.initiateMFA()),
    verifyMFA: (code) => dispatch(ACTIONS.verifyMFA(code)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MFASetup);